// extracted by mini-css-extract-plugin
export default {"status":"NotFound_status__2j403","title":"NotFound_title__LY93S","message":"NotFound_message__-9k1c"};